module.exports = __webpack_public_path__ + "pt_PT-download-cefa0a.webp";